import React, { FC, useCallback } from "react";
import { useTranslation } from "react-i18next";

import { Button } from "@/components/Button";
import { Text } from "@/components/Text";
import { IPageableMeta } from "@/core/api";
import { Flex } from "@/eworkitComponents";

interface ICompactPaginationProps {
  config: IPageableMeta;
  onPageChange: (page: number) => void;
}

export const CompactPagination: FC<ICompactPaginationProps> = ({ config, onPageChange }) => {
  const { t } = useTranslation("common");

  const handlePrevButtonClick = useCallback(() => {
    onPageChange(config.number === 0 ? config.totalPages - 1 : config.number - 1);
  }, [config]);

  const handleNextButtonClick = useCallback(() => {
    onPageChange(config.number === config.totalPages - 1 ? 0 : config.number + 1);
  }, [config]);

  return (
    <Flex direction="row" align="center" innerMargin="sm">
      <Text size="md" color="grey2">
        {t("COMPONENTS.COMPACT_PAGINATION.SHOWING", {
          from: config.number * config.size + 1,
          to: config.number * config.size + config.numberOfElements,
          of: config.totalElements,
        })}
      </Text>

      {config.totalPages > 1 && (
        <>
          <Button size="sm" variant="secondary" icon="arrow" onClick={handlePrevButtonClick} />
          <Button size="sm" variant="secondary" icon="arrow_right" onClick={handleNextButtonClick} />
        </>
      )}
    </Flex>
  );
};
